import type { TwAlertOptions } from '~/definitions/AllDefinitions'

export function formatError(error?: any, t?: any) {
  const ret: TwAlertOptions = {
    headline: '',
    display: true,
    items: [],
    type: 'error',
  }

  const value = error?.value ?? error
  const data = value?.data ?? null

  // Try to use `code` or `message` from data
  let headline = data?.code ?? data?.message ?? ''

  if (!headline && value) {
    if (value.statusCode) {
      headline += value.statusCode
    }
    if (value.statusMessage) {
      if (headline) {
        headline += ' : '
      }
      headline += value.statusMessage
    }
  }

  if (!headline) {
    headline = t ? t('SOMETHING_WENT_WRONG') : 'Something went wrong'
  } else if (t) {
    headline = t(headline)
  }

  ret.headline = headline
  return ret
}

export const defaultError = {
  data: null,
  success: false,
  error: {
    type: 'error',
    display: true,
    headline: 'MISSING_ONE_OR_MORE_PARAMS',
    items: [],
  } as TwAlertOptions,
}
